/**
 * Created by Bazu-05 on 11.06.2020.
 */
const isUndefined = (value) => !value && typeof value === "undefined"

export {
    isUndefined
}
